import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@tonic-one/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function TipModal(props: any) {
  const {
    visible,
    onClose,
    onConfirm,
    loading = false,
    title,
    content,
    children,
  } = props;
  const { t } = useTranslation();

  const useToggle = (defaultValue: boolean) => {
    const [value, setValue] = useState(defaultValue);
    const toggle = () => setValue((value) => !value);
    return [value, toggle];
  };

  const [isOverlayVisible] = useToggle(true);

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={visible}
      onClose={onClose}
      size="md"
    >
      {isOverlayVisible && <ModalOverlay opacity={0.9} />}
      <ModalContent>
        <ModalHeader>{title || ''}</ModalHeader>
        <ModalBody>
          <Text mb="8x">{content || children}</Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            minWidth="20x"
            disabled={loading}
            onClick={onConfirm}
          >
            {t('common.button.ok')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
